const TIMEZONE_LABELS: Record<string, string> = {
    'America/New_York': 'Eastern Time (ET)',
    'America/Chicago': 'Central Time (CT)',
    'America/Denver': 'Mountain Time (MT)',
    'America/Los_Angeles': 'Pacific Time (PT)',
    'America/Anchorage': 'Alaska Time (AKT)',
    'Pacific/Honolulu': 'Hawaii Time (HST)',
};

export function formatTimezoneLabel(timezone: string): string {
    return TIMEZONE_LABELS[timezone] ?? timezone;
}
